import { Buffer } from "buffer";

export function encodeBase64(data: string) {
    return Buffer.from(data).toString("base64");
}

export function decodeBase64(data: string) {
    return Buffer.from(data, "base64");
}
